import React from 'react';
import { useTranslation } from 'react-i18next';
import { Order } from '../../services/exports/Interfaces';
import { DeliveryProvider, ORDER_FULFILLMENT_STATUSES, ORDER_METHODS } from '../../services/exports/Constants';
import useAppMethods from '../../hooks/utility/useAppMethods';
import LoadingIndicator from '../loading/LoadingIndicator';
import DeliveryCarrierIcon from './DeliveryCarrierIcon';
import { Stringable } from '../../services/helpers/Stringable';

interface Props {
  order: Order;
  className?: string;
}

export default function DeliveryTracker({ order, className }: Props) {
  const { t } = useTranslation(null, { keyPrefix: 'Components:Delivery:DeliveryTracker' });

  const { formatCurrency } = useAppMethods();

  const carrier = order?.delivery?.carrier ?? order?.delivery_quote?.carrier;

  return (
    order.method === ORDER_METHODS.DELIVERY &&
    order.delivery_provider !== DeliveryProvider.Standalone &&
    order.fulfillment.status !== ORDER_FULFILLMENT_STATUSES.REJECTED && (
      <div className={className}>
        <div className="flex mt-xs">
          <p className="my-auto mr-xs">{t('labels.delivered_by')}</p>
          <DeliveryCarrierIcon carrier={carrier} className="h-[16px] w-initial my-auto" />
        </div>
        <div className="mt-md p-md rounded-lg bg-[#FDF4EA]">
          <p className="text-sm">
            {t('text', {
              carrier: new Stringable(carrier).capitalize().toString(),
              savings: `5-${formatCurrency(10)}`,
            })}
          </p>
        </div>
        <button
          onClick={() => window.open(order.delivery?.tracking_url, '_blank')}
          disabled={!order.delivery?.tracking_url}
          className="mt-lg flex justify-center items-center py-sm px-2xl text-brand-primary text-center rounded-md border font-medium disabled:bg-white"
        >
          {!order.delivery?.tracking_url ? (
            <LoadingIndicator lg={24} md={24} sm={24} className="mr-xs my-auto" />
          ) : null}
          {t(order.delivery?.tracking_url ? 'buttons.track_order' : 'buttons.track_order_once_confirmed')}
        </button>
      </div>
    )
  );
}
